import { CustomButton, Modal, SvgWarningNew } from '@ui-kit'
import {
  DYNAMIC_QUEUE_CONSTANTS,
  DYNAMIC_QUEUE_MESSAGES,
} from '../../constants/dynamicQueue'
import { ReassignmentConfirmationModalProps } from '../../types/queueConfig.types'

const ReassignmentConfirmationModal = ({
  isOpen,
  conflictLabels,
  entityLabel = DYNAMIC_QUEUE_CONSTANTS.CASE_LOWERCASE,
  onCancel,
  onConfirm,
}: ReassignmentConfirmationModalProps) => {
  const count = conflictLabels.length
  const entityText = count === 1 ? entityLabel : `${entityLabel}s`
  const verb =
    count === 1
      ? DYNAMIC_QUEUE_CONSTANTS.VERB_IS
      : DYNAMIC_QUEUE_CONSTANTS.VERB_ARE
  const pronoun =
    count === 1
      ? DYNAMIC_QUEUE_CONSTANTS.PRONOUN_IT
      : DYNAMIC_QUEUE_CONSTANTS.PRONOUN_THEM

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onCancel}
      showCloseButton={true}
      width="w-[28rem] max-w-[95%]"
      closeModalOnOutsideClick={false}
    >
      <div className="flex flex-col items-center px-6 pb-2 pt-2 font-primary">
        <div className="mb-4 mt-1">
          <SvgWarningNew />
        </div>

        <div className="mb-3 flex items-center justify-center gap-2">
          <span className="flex h-6 min-w-[1.5rem] items-center justify-center rounded border border-primary-500 px-1.5 text-sm font-medium text-accent-900">
            {count}
          </span>
          <span className="text-base font-semibold text-accent-900">
            {DYNAMIC_QUEUE_MESSAGES.ATTENTION_REQUIRED}
          </span>
        </div>

        <p className="mb-4 text-center text-sm font-light text-accent-700">
          {count} {entityText} {verb}{' '}
          {DYNAMIC_QUEUE_MESSAGES.ALREADY_ASSIGNED_TO_AGENT}
          <br />
          {DYNAMIC_QUEUE_MESSAGES.REASSIGN_CONFIRM_QUESTION.replace(
            '{pronoun}',
            pronoun
          )}
        </p>

        {conflictLabels.length > 0 && (
          <div className="mb-6 max-h-40 w-full overflow-y-auto rounded-md border border-tertiary-200 px-4 py-3">
            <ul className="list-disc space-y-1 pl-4 text-sm font-light text-accent-800">
              {conflictLabels.map((label) => (
                <li key={label}>{label}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex w-full gap-3">
          <CustomButton
            onClick={onCancel}
            color="primary"
            className="border border-primary-500 !w-full"
            height="h-9"
            dataQaId={DYNAMIC_QUEUE_CONSTANTS.REASSIGNMENT_CANCEL_QA_ID}
          >
            <span className="text-sm font-light text-accent-900">
              {DYNAMIC_QUEUE_CONSTANTS.CANCEL}
            </span>
          </CustomButton>
          <CustomButton
            onClick={onConfirm}
            color="primary"
            isFilled={true}
            className="!w-full"
            height="h-9"
            dataQaId={DYNAMIC_QUEUE_CONSTANTS.REASSIGNMENT_CONFIRM_QA_ID}
          >
            <span className="text-sm font-light">
              {DYNAMIC_QUEUE_CONSTANTS.CONFIRM}
            </span>
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default ReassignmentConfirmationModal
